module.exports = __webpack_public_path__ + "static/media/Desktop-Lines-Top.0eb22a31.png";